// Fictional company "Pakline", a maker of food packaging (trays, film, boxes)
// selling B2B to food producers. See README.md for the schema.
export default {
  id: 'sales-manager',
  occupationId: '683b01059a1e027695ece64e',
  occupationName: { en: 'Sales manager', ua: 'Менеджер з продажу' },
  format: 'phone',
  title: { en: 'A day as a sales manager', ua: 'День менеджера з продажу' },
  tagline: {
    en: 'Nine days to quarter-end, a buyer with a cheaper quote and a director who wants a number by five',
    ua: 'Дев’ять днів до кінця кварталу, закупівельник із дешевшою пропозицією і директорка, якій потрібна цифра до п’ятої'
  },
  minutes: 10,
  intro: {
    en: 'You sell packaging for Pakline, a 120-person producer of trays, film and boxes for food companies. Your region is a mix of dairies, bakeries and meat plants. The quarter ends in nine days and the plan is 60% done.',
    ua: 'Ти продаєш пакування в Pakline, виробнику лотків, плівки й коробок для харчових компаній на 120 людей. Твій регіон — молокозаводи, пекарні та м’ясокомбінати. До кінця кварталу дев’ять днів, план виконано на 60%.'
  },
  goal: {
    en: 'Close the quarter without giving away the margin or the clients who will still be here next year',
    ua: 'Закрити квартал, не віддавши маржу і клієнтів, які будуть із тобою й наступного року'
  },
  kpis: [
    { key: 'pipeline', label: { en: 'Pipeline', ua: 'Воронка' }, start: 50 },
    { key: 'margin', label: { en: 'Margin', ua: 'Маржа' }, start: 60 },
    { key: 'clients', label: { en: 'Client trust', ua: 'Довіра клієнтів' }, start: 55 }
  ],
  competencies: [
    {
      key: 'negotiation',
      label: { en: 'Negotiation', ua: 'Переговори' },
      skill: { _id: '686282c1aa8e5a92e3bc14b5', name: 'Ведення переговорів' }
    },
    {
      key: 'numbers',
      label: { en: 'Commercial math', ua: 'Комерційна математика' },
      skill: { _id: '686282c1aa8e5a92e3bc15d5', name: 'Фінансовий аналіз' }
    },
    {
      key: 'priorities',
      label: { en: 'Prioritisation', ua: 'Пріоритизація' },
      skill: { _id: '686282c1aa8e5a92e3bc140a', name: 'Управління часом і розстановка пріоритетів' }
    },
    {
      key: 'relationships',
      label: { en: 'Relationships', ua: 'Стосунки з клієнтами' },
      skill: { _id: '686282c1aa8e5a92e3bc1347', name: 'Управління взаємовідносинами з клієнтами' }
    },
    {
      key: 'integrity',
      label: { en: 'Integrity', ua: 'Доброчесність' },
      skill: { _id: '686282c1aa8e5a92e3bc1356', name: 'Відповідальність' }
    }
  ],
  people: [
    {
      key: 'buyer',
      name: { en: 'Oleh', ua: 'Олег' },
      role: {
        en: 'Purchasing manager, Dolyna dairy',
        ua: 'Менеджер закупівель, молокозавод «Долина»'
      },
      initials: 'OL',
      color: '#d5921b'
    },
    {
      key: 'director',
      name: { en: 'Svitlana', ua: 'Світлана' },
      role: { en: 'Sales director', ua: 'Директорка з продажу' },
      initials: 'SV',
      color: '#30b0c7'
    },
    {
      key: 'lost',
      name: { en: 'Tetiana', ua: 'Тетяна' },
      role: {
        en: 'Procurement lead, Stepova meat plant',
        ua: 'Керівниця закупівель, м’ясокомбінат «Степова»'
      },
      initials: 'TE',
      color: '#9c27b0'
    }
  ],
  steps: [
    {
      type: 'chat',
      id: 's1',
      channel: 'call',
      at: '09:10',
      comp: ['negotiation', 'numbers'],
      traits: ['E', 'S'],
      messages: [
        {
          from: 'buyer',
          text: {
            en: 'Morning. I have your quote for the 180×120 trays in front of me, €400 per thousand. Formapak sent me €368 for the same tray yesterday. Same size, same material. Why would I pay you more?',
            ua: 'Доброго ранку. Переді мною ваша пропозиція на лотки 180×120, 18 000 грн за тисячу. «Формапак» учора надіслав 16 560 за такий самий лоток. Той самий розмір, той самий матеріал. Чому я маю платити вам більше?'
          }
        },
        {
          from: 'buyer',
          text: {
            en: 'I need an answer today, the production plan for next month is being signed off this afternoon.',
            ua: 'Відповідь потрібна сьогодні, план виробництва на наступний місяць підписують після обіду.'
          }
        }
      ],
      prompt: { en: 'What do you say on the call?', ua: 'Що кажеш у слухавку?' },
      options: [
        {
          text: {
            en: 'Ask what the 368 includes: delivery to the plant, pallet return, the 0.1 mm tolerance you hold. Then offer a volume step: 400 up to 50 000 a month, 384 above that, with delivery in.',
            ua: 'Спитати, що входить у 16 560: доставка на завод, повернення піддонів, допуск 0,1 мм, який ви тримаєте. Потім запропонувати сходинку за обсягом: 18 000 до 50 000 на місяць, 17 280 понад це, з доставкою.'
          },
          q: 'best',
          fx: { margin: 4, clients: 3 },
          fb: {
            en: 'You moved the conversation from price per thousand to total cost and tied any discount to something you get back. Oleh now compares two different offers, not two numbers.',
            ua: 'Ти перевів розмову з ціни за тисячу на повну вартість і прив’язав будь-яку знижку до того, що отримуєш натомість. Олег тепер порівнює дві різні пропозиції, а не дві цифри.'
          }
        },
        {
          text: {
            en: 'Offer 4% off today if he signs the annual volume this week, and leave it there. Close to the quarter-end, a quick yes is worth more than a perfect price.',
            ua: 'Запропонувати 4% знижки сьогодні, якщо він підпише річний обсяг цього тижня, і на цьому зупинитися. Під кінець кварталу швидке «так» вартує більше за ідеальну ціну.'
          },
          q: 'ok',
          fx: { pipeline: 3, margin: -2 },
          fb: {
            en: "A discount with a condition is sound, but you gave it before learning what the competitor's price actually covers. You may have paid for a problem that did not exist.",
            ua: 'Знижка з умовою — розумно, але ти дав її, не з’ясувавши, що насправді покриває ціна конкурента. Можливо, ти заплатив за проблему, якої не було.'
          }
        },
        {
          text: {
            en: 'Match the 368. Dolyna is a reference client, the trays are a commodity anyway, and losing them over 8% would look much worse on the quarter than a thinner margin.',
            ua: 'Зрівнятися з 16 560. «Долина» — референсний клієнт, лотки й так масовий товар, а втратити їх через 8% виглядало б на кварталі значно гірше, ніж тонша маржа.'
          },
          q: 'bad',
          fx: { pipeline: 4, margin: -8 },
          fb: {
            en: 'You taught Oleh that one sentence about a competitor is worth 8%. Every future call with him starts with that sentence, and the margin never comes back.',
            ua: 'Ти навчив Олега, що одне речення про конкурента коштує 8%. Кожен наступний дзвінок із ним починатиметься з цього речення, а маржа вже не повернеться.'
          },
          later: {
            after: 3,
            note: {
              en: 'Oleh\'s colleague at a second dairy called asking for "the same price you gave Dolyna".',
              ua: 'Колега Олега з іншого молокозаводу подзвонив і попросив «ту саму ціну, що й «Долині»».'
            },
            fx: { margin: -4 }
          }
        },
        {
          text: {
            en: "Tell him Formapak's trays crack in the freezer and he will regret it. You have heard this from two customers and he should know what 368 actually buys.",
            ua: 'Сказати, що лотки «Формапаку» тріскаються в морозилці і він пошкодує. Ти чув це від двох клієнтів, і хай знає, що насправді купує за 16 560.'
          },
          q: 'bad',
          fx: { clients: -6 },
          fb: {
            en: 'Running down a competitor you cannot prove anything about makes you sound scared, and a buyer who hears gossip assumes you do it about him too.',
            ua: 'Паплюжити конкурента, про якого нічого не можеш довести, означає звучати налякано, а покупець, який чує плітки, припускає, що ти пліткуєш і про нього.'
          }
        }
      ],
      principle: {
        en: 'Never answer a price with a price. Answer with what it includes.',
        ua: 'Ніколи не відповідай на ціну ціною. Відповідай тим, що в неї входить.'
      }
    },
    {
      type: 'numeric',
      id: 's2',
      at: '09:45',
      comp: ['numbers'],
      traits: ['I', 'C'],
      text: {
        en: 'Before you call Oleh back, check what his 8% does to the deal. The trays sell at €400 per thousand; production and delivery cost €300 per thousand.',
        ua: 'Перш ніж передзвонити Олегу, порахуй, що його 8% роблять з угодою. Лотки продаються по 18 000 грн за тисячу; виробництво й доставка коштують 13 500 за тисячу.'
      },
      data: [
        { label: { en: 'List price', ua: 'Ціна за прайсом' }, value: '100%' },
        { label: { en: 'Cost, % of list price', ua: 'Собівартість, % від ціни' }, value: '75%' },
        { label: { en: 'Requested discount', ua: 'Запитана знижка' }, value: '8%' }
      ],
      question: {
        en: 'What is the margin after the discount, in % of the new price?',
        ua: 'Яка маржа після знижки, у % від нової ціни?'
      },
      answer: 18.5,
      tolerance: 0.05,
      unit: { en: '%', ua: '%' },
      hint: {
        en: 'Take 8% off the price first, then compare what is left with the cost.',
        ua: 'Спершу зніми 8% з ціни, потім порівняй залишок із собівартістю.'
      },
      explain: {
        en: 'New price: 100 − 8 = 92. Margin: (92 − 75) ÷ 92 = 18.5%, down from 25% before the discount. In money, €400 became €368 against a €300 cost: the discount took a quarter of your margin, not 8% of it.',
        ua: 'Нова ціна: 100 − 8 = 92. Маржа: (92 − 75) ÷ 92 = 18,5% проти 25% до знижки. У грошах 18 000 грн стали 16 560 при собівартості 13 500: знижка з’їла чверть твоєї маржі, а не 8%.'
      },
      fx: { ok: { margin: 5 }, fail: { margin: -4 } }
    },
    {
      type: 'triage',
      id: 's3',
      at: '10:30',
      comp: ['priorities', 'numbers'],
      traits: ['C', 'I'],
      text: {
        en: 'Nine days to quarter-end. Five leads in the CRM and one morning to call. Order them by who you call first.',
        ua: 'Дев’ять днів до кінця кварталу. П’ять лідів у CRM і один ранок на дзвінки. Розстав їх за тим, кому дзвониш першому.'
      },
      items: [
        {
          id: 'dolyna',
          title: {
            en: 'Dolyna dairy: annual tray contract',
            ua: '«Долина»: річний контракт на лотки'
          },
          detail: {
            en: '€48 000. Verbal yes, contract with their lawyers. Close date this Friday. Last contact two days ago.',
            ua: '2 160 000 грн. Усне «так», договір у їхніх юристів. Дата закриття — ця п’ятниця. Останній контакт два дні тому.'
          }
        },
        {
          id: 'bakery',
          title: {
            en: 'Skyba bakery chain: box range',
            ua: 'Мережа пекарень «Скиба»: лінійка коробок'
          },
          detail: {
            en: '€30 000. Proposal sent 12 days ago, no reply. Close date: end of quarter.',
            ua: '1 350 000 грн. Пропозицію надіслано 12 днів тому, відповіді немає. Дата закриття — кінець кварталу.'
          }
        },
        {
          id: 'meat',
          title: {
            en: 'Stepova meat plant: vacuum film',
            ua: 'М’ясокомбінат «Степова»: вакуумна плівка'
          },
          detail: {
            en: '€15 000. Demo done; the buyer asked for samples by Wednesday. Close date next quarter.',
            ua: '675 000 грн. Демо проведено; закупівельниця просила зразки до середи. Закриття — наступного кварталу.'
          }
        },
        {
          id: 'inbound',
          title: {
            en: 'Inbound: frozen-food startup',
            ua: 'Вхідний: стартап заморожених продуктів'
          },
          detail: {
            en: '€6 000. Website request yesterday evening, no call yet. Close date unknown.',
            ua: '270 000 грн. Заявка з сайту вчора ввечері, дзвінка ще не було. Дата закриття невідома.'
          }
        },
        {
          id: 'confect',
          title: {
            en: 'Lasunka confectionery: full packaging switch',
            ua: 'Кондитерська «Ласунка»: повна зміна пакування'
          },
          detail: {
            en: '€80 000. Early discovery, decision in two quarters. Last contact yesterday.',
            ua: '3 600 000 грн. Рання стадія, рішення через два квартали. Останній контакт учора.'
          }
        }
      ],
      correctOrder: ['dolyna', 'bakery', 'meat', 'inbound', 'confect'],
      explain: {
        en: 'Dolyna is the biggest number that can still land this quarter and it has a date this week, so it goes first. Skyba is in-quarter and has been silent for 12 days; one call tells you if it is real. Stepova has a promise with a deadline. The inbound lead goes cold within days but is small. Lasunka is the largest deal and the least urgent: you spoke yesterday and the decision is six months out.',
        ua: '«Долина» — найбільша сума, яка ще може закритися цього кварталу, і дата в неї цього тижня, тож вона перша. «Скиба» в кварталі й мовчить 12 днів; один дзвінок покаже, чи угода жива. «Степова» — обіцянка з дедлайном. Вхідний лід охолоне за кілька днів, але він малий. «Ласунка» — найбільша угода і найменш термінова: ви говорили вчора, а рішення за пів року.'
      },
      fx: { ok: { pipeline: 5 }, fail: { pipeline: -4, energy: -3 } }
    },
    {
      type: 'queue',
      id: 's4',
      at: '11:30',
      comp: ['priorities', 'relationships'],
      traits: ['C', 'S'],
      text: {
        en: 'Three inbound requests sit in the CRM inbox. Open them in the order you think is right and decide on each.',
        ua: 'У вхідних CRM три запити. Відкрий їх у тому порядку, який вважаєш правильним, і прийми рішення по кожному.'
      },
      tickets: [
        {
          id: 't1',
          from: {
            en: 'Lasunka confectionery, procurement',
            ua: 'Кондитерська «Ласунка», закупівлі'
          },
          urgency: 3,
          sla: { en: '1 h', ua: '1 год' },
          subject: {
            en: 'Urgent: 20 000 boxes within 10 days',
            ua: 'Терміново: 20 000 коробок за 10 днів'
          },
          body: {
            en: 'Our current supplier missed a delivery and the Easter line starts in 10 days. Can you supply 20 000 printed boxes, 250×250×80, by then? Price and date today, please.',
            ua: 'Наш постачальник зірвав поставку, а великодня лінія стартує за 10 днів. Чи зможете дати 20 000 друкованих коробок 250×250×80 до того часу? Ціну й дату сьогодні, будь ласка.'
          },
          options: [
            {
              text: {
                en: 'Call within the hour, get the artwork and quantity confirmed, and check the print slot with production before you name a date. Quote this afternoon.',
                ua: 'Подзвонити протягом години, підтвердити макет і кількість і перевірити вікно друку з виробництвом, перш ніж називати дату. Прорахунок дати після обіду.'
              },
              q: 'best',
              fx: { pipeline: 5, clients: 3 },
              fb: {
                en: 'A rescue order is how a two-quarter prospect becomes a client this month, but only if the date you give is real. Production first, promise second.',
                ua: 'Рятівне замовлення — так клієнт із горизонтом у два квартали стає клієнтом цього місяця, але лише якщо названа дата справжня. Спершу виробництво, потім обіцянка.'
              }
            },
            {
              text: {
                en: 'Email the standard price list and lead times straight away so they have something, and schedule a call for tomorrow when you know the plan.',
                ua: 'Одразу надіслати стандартний прайс і терміни, щоб у них щось було, і призначити дзвінок на завтра, коли знатимеш план виробництва.'
              },
              q: 'ok',
              fx: { pipeline: 1 },
              fb: {
                en: 'They asked for a date today and got a PDF. By tomorrow a competitor who picked up the phone has the order.',
                ua: 'Вони просили дату сьогодні, а отримали PDF. До завтра замовлення вже в конкурента, який узяв слухавку.'
              }
            },
            {
              text: {
                en: 'Confirm 10 days on the spot, the print shop usually turns boxes in a week, and sort out the production slot after the deal is in.',
                ua: 'Підтвердити 10 днів одразу, друк зазвичай робить коробки за тиждень, а вікно на виробництві узгодити вже після того, як угода в кишені.'
              },
              q: 'bad',
              fx: { pipeline: 4, clients: -2 },
              fb: {
                en: '"Usually" is not a production slot. Missing a rescue order\'s date is worse than declining it: they came to you because the last supplier did exactly this.',
                ua: '«Зазвичай» — не вікно на виробництві. Зірвати дату рятівного замовлення гірше, ніж відмовити: вони прийшли до тебе саме тому, що попередній постачальник зробив те саме.'
              },
              later: {
                after: 2,
                note: {
                  en: 'Production says the first free print slot is in 12 days. You now have to call Lasunka back with a date you already promised.',
                  ua: 'Виробництво каже, що перше вільне вікно друку за 12 днів. Тепер треба передзвонити «Ласунці» з датою, яку ти вже обіцяв.'
                },
                fx: { clients: -8 }
              }
            }
          ]
        },
        {
          id: 't2',
          from: {
            en: 'Pivnich fish processing, technologist',
            ua: 'Рибопереробка «Північ», технолог'
          },
          urgency: 2,
          sla: { en: 'today', ua: 'сьогодні' },
          subject: {
            en: 'Samples and food-contact certificates',
            ua: 'Зразки і сертифікати на контакт з харчами'
          },
          body: {
            en: 'We are testing new trays for smoked fish. Could you send samples of three sizes with the food-contact declarations? Our quality team meets next Tuesday.',
            ua: 'Тестуємо нові лотки під копчену рибу. Можете надіслати зразки трьох розмірів із деклараціями на контакт з харчовими продуктами? Наша служба якості збирається наступного вівторка.'
          },
          options: [
            {
              text: {
                en: 'Send the samples and declarations by courier today and book a 15-minute call for Wednesday to hear what the quality team said.',
                ua: 'Відправити зразки й декларації кур’єром сьогодні і призначити 15-хвилинний дзвінок на середу, щоб почути, що сказала служба якості.'
              },
              q: 'best',
              fx: { pipeline: 3, clients: 2 },
              fb: {
                en: 'Samples with a follow-up date are a sales step; samples alone are a parcel. You will know on Wednesday whether this is a deal or a test.',
                ua: 'Зразки з датою наступного контакту — це крок продажу; зразки самі по собі — посилка. У середу ти знатимеш, угода це чи просто тест.'
              }
            },
            {
              text: {
                en: 'Send the samples today; the declarations take a request to quality, so promise them by Monday. It is enough for a first look.',
                ua: 'Відправити зразки сьогодні; декларації треба запитати в службі якості, тож пообіцяти їх до понеділка. Для першого погляду достатньо.'
              },
              q: 'ok',
              fx: { pipeline: 1 },
              fb: {
                en: 'A technologist cannot approve a tray without the paper. Monday is a day before their meeting, and one delay makes you the risky supplier.',
                ua: 'Технолог не затвердить лоток без паперу. Понеділок — за день до їхньої зустрічі, і одна затримка робить тебе ризикованим постачальником.'
              }
            },
            {
              text: {
                en: 'Reply that samples go out after a trial order of one pallet; sending free samples to every technologist who asks is how the sample budget disappears.',
                ua: 'Відповісти, що зразки відправляємо після пробного замовлення на один піддон; роздавати зразки кожному технологу — так зникає бюджет на зразки.'
              },
              q: 'bad',
              fx: { pipeline: -4, clients: -3 },
              fb: {
                en: 'Three trays and a courier cost less than one hour of your time. You asked a buyer to commit before testing, which no quality team can agree to.',
                ua: 'Три лотки й кур’єр коштують менше за годину твого часу. Ти попросив покупця взяти зобов’язання до тесту, на що жодна служба якості не піде.'
              }
            }
          ]
        },
        {
          id: 't3',
          from: { en: 'Dolyna dairy, warehouse', ua: '«Долина», склад' },
          urgency: 1,
          sla: { en: '2 days', ua: '2 дні' },
          subject: {
            en: 'Reorder: 5 pallets of stretch film',
            ua: 'Повторне замовлення: 5 піддонів стретч-плівки'
          },
          body: {
            en: 'Same film as last month, 5 pallets, delivery next week. Send the invoice to the usual address.',
            ua: 'Та сама плівка, що минулого місяця, 5 піддонів, доставка наступного тижня. Рахунок на звичну адресу.'
          },
          options: [
            {
              text: {
                en: 'Pass it to the order desk with a CRM note, confirm the delivery date to the warehouse by message, and leave it there.',
                ua: 'Передати відділу замовлень із нотаткою в CRM, підтвердити складу дату доставки коротким повідомленням і більше до цього не повертатися.'
              },
              q: 'best',
              fx: { margin: 1, energy: 2 },
              fb: {
                en: 'A routine reorder is a process, not a sales call. Ten minutes and a confirmation keep the client calm and your morning free for the deals that need you.',
                ua: 'Рутинне повторне замовлення — це процес, а не продаж. Десять хвилин і підтвердження тримають клієнта спокійним, а твій ранок вільним для угод, які потребують тебе.'
              }
            },
            {
              text: {
                en: 'Process it yourself end to end: check stock, raise the invoice, book the truck. It is Dolyna, and this week nothing with their name on it should go wrong.',
                ua: 'Провести самому від початку до кінця: перевірити залишки, виставити рахунок, замовити машину. Це «Долина», і цього тижня нічого з їхнім іменем не має піти не так.'
              },
              q: 'ok',
              fx: { energy: -6 },
              fb: {
                en: 'Careful, but an hour of admin while four in-quarter deals wait. The order desk exists so that you do not do this.',
                ua: 'Обережно, але це година адміністративки, поки чотири угоди кварталу чекають. Відділ замовлень існує саме для того, щоб ти цього не робив.'
              }
            },
            {
              text: {
                en: 'Hold the film until the annual tray contract is signed on Friday. A delivery they need next week is useful leverage for a deal you need this week.',
                ua: 'Притримати плівку, поки в п’ятницю не підпишуть річний контракт на лотки. Доставка, потрібна їм наступного тижня, — корисний важіль для угоди, потрібної тобі цього тижня.'
              },
              q: 'bad',
              fx: { clients: -10, pipeline: -3 },
              fb: {
                en: 'You turned a routine delivery into a hostage. Oleh will sign the contract, remember this, and open the next tender to three suppliers.',
                ua: 'Ти перетворив рутинну доставку на заручника. Олег підпише контракт, запам’ятає це і відкриє наступний тендер трьом постачальникам.'
              }
            }
          ]
        }
      ]
    },
    {
      type: 'choice',
      id: 's5',
      at: '13:00',
      comp: ['integrity', 'relationships'],
      traits: ['E', 'C'],
      text: {
        en: 'Lunch with the purchasing manager of the Skyba bakery chain. Over coffee he says: "Put the box price €2 above your quote, per thousand. The difference comes to me personally, and your director gets a better price than she expected. Everyone wins."',
        ua: 'Обід із менеджером закупівель мережі пекарень «Скиба». За кавою він каже: «Постав ціну на коробки на 90 грн вищу за твою пропозицію, за тисячу. Різниця — мені особисто, а твоя директорка отримає кращу ціну, ніж чекала. Усі у виграші».'
      },
      options: [
        {
          text: {
            en: 'Decline plainly: you sell only at the official price and terms. Then move on to what you can do: a volume discount for Skyba as a company. Note the conversation in the CRM afterwards.',
            ua: 'Чітко відмовити: ти продаєш лише за офіційною ціною й умовами. Потім перейти до того, що можеш: знижка за обсяг для «Скиби» як компанії. Після обіду зафіксувати розмову в CRM.'
          },
          q: 'best',
          fx: { clients: 2, margin: 2 },
          fb: {
            en: 'A clean no with a next sentence keeps the deal alive and ends the test. The CRM note protects you if the story is ever told differently.',
            ua: 'Чисте «ні» з наступним реченням зберігає угоду й закриває перевірку. Нотатка в CRM захищає тебе, якщо цю історію колись розкажуть інакше.'
          }
        },
        {
          text: {
            en: 'Change the subject without answering, finish lunch talking product and delivery schedule, and hope he does not raise it again before signing.',
            ua: 'Змінити тему, не відповідаючи, дообідати за розмовою про продукт і графік поставок і сподіватися, що до підписання він більше цього не підніме.'
          },
          q: 'ok',
          fx: { clients: -1, energy: -3 },
          fb: {
            en: 'Silence is read as "maybe". He will ask again at the contract stage, and the second time it is harder to refuse without an awkward scene.',
            ua: 'Мовчання читається як «можливо». Він спитає знову на етапі договору, і вдруге відмовити без незручної сцени буде складніше.'
          }
        },
        {
          text: {
            en: 'Agree just this once. The deal is €30 000 in-quarter, the surcharge is invisible in the price, and refusing probably means losing Skyba to someone who says yes.',
            ua: 'Погодитися лише цього разу. Угода на 1 350 000 грн у кварталі, надбавка в ціні непомітна, а відмова, найімовірніше, означає втратити «Скибу» на користь того, хто скаже «так».'
          },
          q: 'bad',
          fx: { pipeline: 5 },
          fb: {
            en: 'A kickback is bribery, a dismissal offence and a crime, and "once" is how it always starts. From now on he owns you in every negotiation.',
            ua: 'Відкат — це хабар, підстава для звільнення і злочин, і «лише раз» — так це завжди починається. Відтепер він володіє тобою в кожних переговорах.'
          },
          later: {
            after: 2,
            note: {
              en: 'Svitlana asks why the Skyba box price is above the list price. You do not have a good answer.',
              ua: 'Світлана питає, чому ціна коробок для «Скиби» вища за прайс. Доброї відповіді в тебе немає.'
            },
            fx: { clients: -10, margin: -5 }
          }
        },
        {
          text: {
            en: 'Laugh it off and say "let us sign the contract first, then we will see". It keeps him warm, commits you to nothing, and the deal stays on track for the quarter.',
            ua: 'Відбутися жартом і сказати «спершу підпишемо контракт, а там подивимось». Це тримає його теплим, ні до чого не зобов’язує, а угода лишається в кварталі.'
          },
          q: 'bad',
          fx: { pipeline: 2, clients: -4 },
          fb: {
            en: 'He heard a yes with a delay. When the contract is signed and you say no, you are the one who broke a promise, and the account turns hostile.',
            ua: 'Він почув «так» із відстрочкою. Коли контракт підпишуть і ти скажеш «ні», обіцянку порушив ти, і клієнт стає ворожим.'
          }
        }
      ],
      principle: {
        en: 'A kickback is not a negotiation. Decline in one sentence and keep selling.',
        ua: 'Відкат — не переговори. Відмов одним реченням і продавай далі.'
      }
    },
    {
      type: 'allocate',
      id: 's6',
      at: '14:00',
      comp: ['priorities', 'relationships'],
      traits: ['E', 'I'],
      text: {
        en: 'Plan the remaining eight working days of the quarter. Split your time across four kinds of work.',
        ua: 'Сплануй решту восьми робочих днів кварталу. Розподіли час між чотирма видами роботи.'
      },
      buckets: [
        {
          id: 'follow',
          label: { en: 'Follow-ups on open deals', ua: 'Дотискання відкритих угод' },
          hint: {
            en: '70% of what is left on the plan sits in four deals waiting for your next call.',
            ua: '70% того, що лишилося до плану, сидить у чотирьох угодах, які чекають твого наступного дзвінка.'
          },
          best: 40
        },
        {
          id: 'visits',
          label: { en: 'Visits and demos', ua: 'Візити та демо' },
          hint: {
            en: 'A visit closes twice as often as a call, but costs half a day with travel.',
            ua: 'Візит закриває вдвічі частіше за дзвінок, але з дорогою з’їдає пів дня.'
          },
          best: 30
        },
        {
          id: 'prospect',
          label: { en: 'Prospecting', ua: 'Пошук нових клієнтів' },
          hint: {
            en: 'Feeds next quarter; the pipeline needs three times the plan in it by then.',
            ua: 'Годує наступний квартал; до того часу у воронці має бути втричі більше за план.'
          },
          best: 15
        },
        {
          id: 'admin',
          label: { en: 'CRM and paperwork', ua: 'CRM і документи' },
          hint: {
            en: 'Svitlana reads the forecast on Friday; a deal that is not in the CRM does not count.',
            ua: 'Світлана читає прогноз у п’ятницю; угоди, якої немає в CRM, не існує.'
          },
          best: 15
        }
      ],
      explain: {
        en: 'With eight days left, the plan is made or lost in the deals that already exist, so follow-ups and visits take 70% between them. Prospecting cannot be zero or next quarter starts empty. CRM gets a real slice because an unlogged deal is invisible to the forecast.',
        ua: 'Коли лишилося вісім днів, план робиться або губиться в угодах, які вже є, тому дотискання й візити разом беруть 70%. Пошук не може бути нулем, інакше наступний квартал почнеться порожнім. CRM отримує справжню частку, бо незафіксована угода невидима для прогнозу.'
      },
      fx: { ok: { pipeline: 6 }, fail: { pipeline: -5 } }
    },
    {
      type: 'chat',
      id: 's7',
      channel: 'call',
      at: '15:00',
      comp: ['relationships', 'negotiation'],
      traits: ['S', 'E'],
      messages: [
        {
          from: 'lost',
          text: {
            en: 'Hi. I wanted to tell you myself: we signed the film contract with another supplier this morning. Thank you for the demo and the samples, the team liked them. It was a close call.',
            ua: 'Привіт. Хотіла сказати сама: сьогодні зранку ми підписали контракт на плівку з іншим постачальником. Дякую за демо і зразки, команді вони сподобалися. Рішення було непростим.'
          }
        }
      ],
      prompt: { en: 'What do you reply?', ua: 'Що відповідаєш?' },
      options: [
        {
          text: {
            en: 'Thank her for calling herself, congratulate her on closing, and ask two things: what tipped the decision, and whether you may check in before the contract renews. Send the tolerance spec anyway.',
            ua: 'Подякувати, що сказала сама, привітати із закриттям і спитати дві речі: що схилило рішення і чи можна нагадати про себе перед продовженням контракту. Специфікацію допусків надіслати все одно.'
          },
          q: 'best',
          fx: { clients: 5, pipeline: 1 },
          fb: {
            en: 'A lost deal is the cheapest market research you will get this quarter, and a graceful exit is why she calls you first when the new supplier slips.',
            ua: 'Програна угода — найдешевше дослідження ринку цього кварталу, а гідний вихід — причина, чому вона подзвонить першому тобі, коли новий постачальник підведе.'
          }
        },
        {
          text: {
            en: 'Ask whether there is any chance to revisit if you improve the price: the quarter is not over, and you could probably find another 3% for a signed annual volume.',
            ua: 'Спитати, чи є шанс переглянути рішення, якщо ти покращиш ціну: квартал ще не закінчився, і ти, мабуть, знайшов би ще 3% за підписаний річний обсяг.'
          },
          q: 'ok',
          fx: { margin: -2, clients: -2 },
          fb: {
            en: 'She has signed. A late discount tells her your first price had air in it, and it does not change a contract her lawyers already stamped.',
            ua: 'Вона вже підписала. Пізня знижка каже їй, що в першій ціні було повітря, і не змінює контракт, який її юристи вже проштампували.'
          }
        },
        {
          text: {
            en: 'Warn her, politely, that the supplier she chose had two recalls last year and that you will keep the proposal open in case things go wrong with the new one.',
            ua: 'Ввічливо попередити, що в обраного постачальника торік було два відкликання продукції, і що ти тримаєш пропозицію відкритою на випадок, якщо щось піде не так.'
          },
          q: 'bad',
          fx: { clients: -6 },
          fb: {
            en: 'She just made a decision and you told her it was a mistake. People defend their decisions; now she defends it against you.',
            ua: 'Вона щойно ухвалила рішення, а ти сказав їй, що це помилка. Люди захищають свої рішення; тепер вона захищає його від тебе.'
          }
        },
        {
          text: {
            en: 'Say "understood, thanks for letting me know", mark the deal as lost in the CRM with today\'s date and move on to the calls that can still close this quarter.',
            ua: 'Сказати «зрозумів, дякую, що повідомила», позначити угоду в CRM як програну з сьогоднішньою датою і перейти до дзвінків, які ще можуть закритися цього кварталу.'
          },
          q: 'bad',
          fx: { energy: 2, clients: -3, pipeline: -2 },
          fb: {
            en: 'Efficient and empty. You learned nothing about why you lost and left no reason for her to come back in a year.',
            ua: 'Ефективно і порожньо. Ти не дізнався нічого про те, чому програв, і не лишив їй причини повернутися за рік.'
          }
        }
      ],
      principle: {
        en: 'Lose well. The next deal with this client starts today.',
        ua: 'Програвай гідно. Наступна угода з цим клієнтом починається сьогодні.'
      }
    },
    {
      type: 'chat',
      id: 's8',
      at: '16:30',
      comp: ['integrity', 'numbers'],
      traits: ['E', 'C'],
      messages: [
        {
          from: 'director',
          text: {
            en: 'I need your commit for the quarter by 17:00. The board expects €200 000 from your region. Dolyna, Skyba, the frozen-food lead, what can I count on?',
            ua: 'Мені потрібен твій коміт на квартал до 17:00. Правління чекає від твого регіону 9 000 000 грн. «Долина», «Скиба», заморозка — на що я можу розраховувати?'
          }
        },
        {
          from: 'director',
          text: {
            en: 'And please, no surprises on the 30th like last time.',
            ua: 'І, будь ласка, без сюрпризів 30-го, як минулого разу.'
          }
        }
      ],
      prompt: {
        en: 'Your honest view: €120 000 already closed, Dolyna €48 000 likely by Friday, Skyba €30 000 silent for 12 days, nothing else lands in time. What do you send?',
        ua: 'Твоя чесна картина: 5 400 000 грн уже закрито, «Долина» 2 160 000 імовірно до п’ятниці, «Скиба» 1 350 000 мовчить 12 днів, більше нічого не встигає. Що надсилаєш?'
      },
      options: [
        {
          text: {
            en: 'Commit €168 000: closed plus Dolyna. Skyba €30 000 as upside with the reason it is uncertain, and one ask: her sign-off on the Dolyna volume terms today so Friday does not slip.',
            ua: 'Коміт 7 560 000 грн: закрите плюс «Долина». «Скиба» 1 350 000 — як апсайд із причиною невизначеності, і одне прохання: її підпис на умовах за обсягом для «Долини» сьогодні, щоб п’ятниця не зсунулася.'
          },
          q: 'best',
          fx: { trust: 6, pipeline: 2 },
          fb: {
            en: 'A commit she can take to the board, an upside she can plan around, and a request that makes her part of closing it. That is a forecast, not a hope.',
            ua: 'Коміт, який вона може нести правлінню, апсайд, навколо якого можна планувати, і прохання, яке робить її частиною закриття. Це прогноз, а не надія.'
          }
        },
        {
          text: {
            en: 'Commit €150 000 to be safe: closed plus most of Dolyna. If Dolyna and Skyba both land you will beat the number, and nobody is punished for beating a number.',
            ua: 'Закомітити 6 750 000 грн, щоб напевно: закрите плюс більша частина «Долини». Якщо «Долина» й «Скиба» закриються, ти переб’єш цифру, а за перевиконання не карають.'
          },
          q: 'ok',
          fx: { trust: -2 },
          fb: {
            en: 'Sandbagging feels safe, but Svitlana plans production and bonuses on your number. A forecast that is always beaten is as useless as one that is always missed.',
            ua: 'Занижувати здається безпечним, але Світлана планує виробництво й бонуси за твоєю цифрою. Прогноз, який завжди перевиконують, так само марний, як і той, якого завжди не досягають.'
          }
        },
        {
          text: {
            en: 'Commit the full €200 000. Dolyna is practically signed, Skyba will answer once you call, and committing less tells the board your region cannot deliver.',
            ua: 'Закомітити всі 9 000 000 грн. «Долина» практично підписана, «Скиба» відповість, щойно ти подзвониш, а менший коміт скаже правлінню, що твій регіон не тягне.'
          },
          q: 'bad',
          fx: { trust: 3 },
          fb: {
            en: 'You committed a deal that has been silent for 12 days. The surprise she asked you to avoid is now scheduled for the 30th.',
            ua: 'Ти закомітив угоду, яка мовчить 12 днів. Сюрприз, якого вона просила уникнути, тепер запланований на 30-те.'
          },
          later: {
            after: 1,
            note: {
              en: 'Skyba has not replied. Svitlana already told the board €200 000. The 30th is going to be a long day.',
              ua: '«Скиба» не відповіла. Світлана вже назвала правлінню 9 000 000. 30-те буде довгим днем.'
            },
            fx: { trust: -12 }
          }
        },
        {
          text: {
            en: 'Ask her to wait until Friday: by then Dolyna will have signed and Skyba will have replied, and any number before that is a guess you would rather not put your name on.',
            ua: 'Попросити зачекати до п’ятниці: до того часу «Долина» підпише, а «Скиба» відповість, а будь-яка цифра до того — здогадка, під якою ти не хотів би підписуватися.'
          },
          q: 'bad',
          fx: { trust: -6 },
          fb: {
            en: 'She asked at 16:30 because the board meets before Friday. A salesperson who cannot forecast under uncertainty is not forecasting, only reporting.',
            ua: 'Вона питає о 16:30, бо правління збирається до п’ятниці. Продавець, який не вміє прогнозувати в невизначеності, не прогнозує, а лише звітує.'
          }
        }
      ],
      principle: {
        en: 'Commit what you would bet your bonus on. Name the rest as upside.',
        ua: 'Коміть те, на що поставив би свій бонус. Решту називай апсайдом.'
      }
    },
    {
      type: 'spot',
      id: 's9',
      at: '17:30',
      comp: ['numbers', 'negotiation'],
      traits: ['C'],
      text: {
        en: 'The order desk drafted the Dolyna contract annex from your call notes. You agreed 42 000 trays a month at list price with a 4% volume discount, delivery to the plant, payment in 30 days. It has 3 mistakes. Tap each one.',
        ua: 'Відділ замовлень склав додаток до договору з «Долиною» за твоїми нотатками. Ви домовилися: 42 000 лотків на місяць за прайсом зі знижкою 4% за обсяг, доставка на завод, оплата за 30 днів. У ньому 3 помилки. Натисни на кожну.'
      },
      mock: {
        kind: 'card',
        title: {
          en: 'Annex 1 to supply contract: Dolyna dairy',
          ua: 'Додаток 1 до договору поставки: молокозавод «Долина»'
        },
        blocks: [
          {
            id: 'b1',
            kind: 'heading',
            label: { en: 'Supply terms, trays 180×120', ua: 'Умови поставки, лотки 180×120' },
            value: ''
          },
          {
            id: 'b2',
            kind: 'field',
            label: { en: 'Product', ua: 'Продукт' },
            value: { en: 'Tray 180×120, food-grade PP', ua: 'Лоток 180×120, харчовий ПП' }
          },
          {
            id: 'b3',
            kind: 'field',
            label: { en: 'Monthly quantity', ua: 'Обсяг на місяць' },
            value: '48 000',
            issue: {
              en: 'You agreed 42 000 a month. Overstating volume by 6 000 is a dispute at the first invoice.',
              ua: 'Ви домовилися про 42 000 на місяць. Завищений на 6 000 обсяг — спір уже на першому рахунку.'
            }
          },
          {
            id: 'b4',
            kind: 'line',
            label: { en: 'List price per 1 000', ua: 'Прайс за 1 000' },
            value: { en: '€400', ua: '18 000 грн' }
          },
          {
            id: 'b5',
            kind: 'line',
            label: { en: 'Volume discount', ua: 'Знижка за обсяг' },
            value: '8%',
            issue: {
              en: 'You agreed 4%. An 8% line turns your 25% margin into 18.5%.',
              ua: 'Ви домовилися про 4%. Рядок із 8% перетворює твою маржу з 25% на 18,5%.'
            }
          },
          {
            id: 'b6',
            kind: 'field',
            label: { en: 'Delivery', ua: 'Доставка' },
            value: {
              en: 'To the Dolyna plant, pallets returned',
              ua: 'На завод «Долини», піддони повертаються'
            }
          },
          {
            id: 'b7',
            kind: 'field',
            label: { en: 'Payment', ua: 'Оплата' },
            value: { en: '30 days from delivery', ua: '30 днів від поставки' }
          },
          {
            id: 'b8',
            kind: 'field',
            label: { en: 'Prices valid until', ua: 'Ціни дійсні до' },
            value: '31.11.2026',
            issue: {
              en: 'November has 30 days. A contract with an impossible date goes back to the lawyers.',
              ua: 'У листопаді 30 днів. Договір із неможливою датою повертається до юристів.'
            }
          },
          {
            id: 'b9',
            kind: 'button',
            label: { en: 'Send to client', ua: 'Надіслати клієнту' },
            value: ''
          }
        ]
      },
      explain: {
        en: 'Quantity 48 000 against the agreed 42 000 and discount 8% against the agreed 4% are both commercial errors that cost margin or trust. The validity date 31.11 does not exist. Price, delivery and payment terms match the call.',
        ua: 'Обсяг 48 000 замість домовлених 42 000 і знижка 8% замість 4% — комерційні помилки, які коштують маржі або довіри. Дати 31.11 не існує. Ціна, доставка й умови оплати відповідають дзвінку.'
      },
      fx: { ok: { margin: 5, clients: 3 }, fail: { margin: -5 } }
    }
  ],
  verdict: {
    bands: [
      {
        min: 0.8,
        title: { en: 'You could carry a region tomorrow', ua: 'Ти міг би вести регіон уже завтра' },
        text: {
          en: 'You answered price with value, said no to the kickback in one sentence and forecast what you would bet on. That is what a senior salesperson looks like.',
          ua: 'Ти відповідав на ціну цінністю, відмовив відкату одним реченням і прогнозував те, на що поставив би сам. Так виглядає сеньйор у продажах.'
        }
      },
      {
        min: 0.6,
        title: {
          en: 'Solid closer with a soft spot for discounts',
          ua: 'Впевнений продавець зі слабкістю до знижок'
        },
        text: {
          en: 'Most calls landed; the misses were about giving away margin before learning what the client actually needed.',
          ua: 'Більшість рішень влучні; промахи — про те, що ти віддавав маржу раніше, ніж дізнавався, що насправді треба клієнту.'
        }
      },
      {
        min: 0.4,
        title: {
          en: 'You would hit some quarters and burn some clients',
          ua: 'Ти б закривав деякі квартали й спалював деяких клієнтів'
        },
        text: {
          en: "You tend to optimise for this month's number over next year's account. Re-read the feedback on the lost deal and the reorder.",
          ua: 'Ти схильний оптимізувати цифру цього місяця коштом клієнта наступного року. Перечитай фідбек до програної угоди та повторного замовлення.'
        }
      },
      {
        min: 0,
        title: { en: 'This quarter would have eaten you', ua: 'Цей квартал би тебе з’їв' },
        text: {
          en: 'Many choices bought a yes today and paid for it in margin, trust or your own name. Sales is the opposite: say the price, keep the relationship.',
          ua: 'Багато рішень купували «так» сьогодні й платили за нього маржею, довірою або власним іменем. Продажі — навпаки: назви ціну, збережи стосунки.'
        }
      }
    ],
    reality: [
      {
        en: 'About two hours a day is the CRM: notes, next steps, forecast fields. Unlogged work is work nobody believes happened.',
        ua: 'Близько двох годин на день — це CRM: нотатки, наступні кроки, поля прогнозу. Незафіксована робота — робота, в яку ніхто не вірить.'
      },
      {
        en: 'Two of every three deals you work on are lost or stall. The job is making the third one worth it and learning something from the other two.',
        ua: 'Дві з кожних трьох угод, над якими працюєш, програються або зависають. Робота — зробити третю вартою того і чомусь навчитися з двох інших.'
      },
      {
        en: 'Once a quarter someone hints at a personal arrangement. Your answer has to be ready before you hear it.',
        ua: 'Раз на квартал хтось натякає на особисту домовленість. Твоя відповідь має бути готова до того, як ти її почуєш.'
      }
    ]
  }
};
